/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DatanormOnlineAvailabilityQueryVariables = Types.Exact<{
  itekCompanyId: Types.Scalars['ID']['input'];
}>;


export type DatanormOnlineAvailabilityQuery = { datanormOnlineAvailability?: { __typename: 'DatanormOnlineAvailability', itekCompanyId: string, usernameRequired: boolean, clientIdRequired: boolean, passwordRequired: boolean } | null };


export const DatanormOnlineAvailabilityDocument = gql`
    query DatanormOnlineAvailability($itekCompanyId: ID!) {
  datanormOnlineAvailability(itekCompanyId: $itekCompanyId) {
    itekCompanyId
    usernameRequired
    clientIdRequired
    passwordRequired
  }
}
    `;

/**
 * __useDatanormOnlineAvailabilityQuery__
 *
 * To run a query within a React component, call `useDatanormOnlineAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useDatanormOnlineAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDatanormOnlineAvailabilityQuery({
 *   variables: {
 *      itekCompanyId: // value for 'itekCompanyId'
 *   },
 * });
 */
export function useDatanormOnlineAvailabilityQuery(baseOptions: Apollo.QueryHookOptions<DatanormOnlineAvailabilityQuery, DatanormOnlineAvailabilityQueryVariables> & ({ variables: DatanormOnlineAvailabilityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DatanormOnlineAvailabilityQuery, DatanormOnlineAvailabilityQueryVariables>(DatanormOnlineAvailabilityDocument, options);
      }
export function useDatanormOnlineAvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DatanormOnlineAvailabilityQuery, DatanormOnlineAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DatanormOnlineAvailabilityQuery, DatanormOnlineAvailabilityQueryVariables>(DatanormOnlineAvailabilityDocument, options);
        }
export function useDatanormOnlineAvailabilitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DatanormOnlineAvailabilityQuery, DatanormOnlineAvailabilityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DatanormOnlineAvailabilityQuery, DatanormOnlineAvailabilityQueryVariables>(DatanormOnlineAvailabilityDocument, options);
        }
export type DatanormOnlineAvailabilityQueryHookResult = ReturnType<typeof useDatanormOnlineAvailabilityQuery>;
export type DatanormOnlineAvailabilityLazyQueryHookResult = ReturnType<typeof useDatanormOnlineAvailabilityLazyQuery>;
export type DatanormOnlineAvailabilitySuspenseQueryHookResult = ReturnType<typeof useDatanormOnlineAvailabilitySuspenseQuery>;
export type DatanormOnlineAvailabilityQueryResult = Apollo.QueryResult<DatanormOnlineAvailabilityQuery, DatanormOnlineAvailabilityQueryVariables>;